import { render, staticRenderFns } from "./corporate_profile.vue?vue&type=template&id=500e2332&scoped=true"
import script from "./corporate_profile.vue?vue&type=script&lang=js"
export * from "./corporate_profile.vue?vue&type=script&lang=js"
import style0 from "./corporate_profile.vue?vue&type=style&index=0&id=500e2332&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500e2332",
  null
  
)

export default component.exports